import { Components, Theme } from '@mui/material'

export const MuiDialog: Components<Omit<Theme, 'components'>>['MuiDialog'] = {
  defaultProps: {
    maxWidth: 'sm',
    fullWidth: true,
  },
  styleOverrides: {
    paper: {
      border: 0,
    },
  },
}
